import { getRegistryItemRequestedQuantity, getRegistryItemPurchasedQuantity } from '../utils/registryUtils';
import { getTargetedProduct } from '../../../product/js/utils/utils';

export function getAddToRegistryEntity(getState, action) {
    const product = getTargetedProduct(getState, action.meta.component);
    return {
        items: [{
            channel: 'WEB_DESKTOP',
            favorite: false,
            /* eslint-disable camelcase */
            product_id: product.styleNumber,
            requested_quantity: product.productControls.quantity,
            /* eslint-enable camelcase */
            sku: product.selectedSku.sku.skuId,
            store: ''
        }]
    };
}

export function getRemoveFromRegistryEntity(state) {
    const product = getTargetedProduct(state);
    return {
        version: product.productRegistry.registry.version
    };
}

export function getUpdateRegistryItemEntity(state) {
    const product = getTargetedProduct(state);
    return {
        items: [
            {
                channel: 'WEB_DESKTOP',
                favorite: false,
                /* eslint-disable camelcase */
                product_id: product.productRegistry.selectedItem.catalogInfo.styleNumber,
                requested_quantity: getRegistryItemRequestedQuantity(state),
                /* eslint-enable camelcase */
                sku: product.selectedSku.sku.skuId
            }
        ]
    };
}

export function getUpdateRegistryItemQuantityEntity(state) {
    const product = getTargetedProduct(state);
    return [
        {
            op: 'test',
            path: '/version',
            value: product.productRegistry.registry.version
        },
        {
            op: 'replace',
            path: 'requested_quantity',
            value: getRegistryItemRequestedQuantity(state)
        }
    ];
}

export function getUpdateRegistryItemPurchasedEntity(state) {
    const product = getTargetedProduct(state);
    return [
        {
            op: 'test',
            path: '/version',
            value: product.productRegistry.registry.version
        },
        {
            op: 'replace',
            path: 'purchased_quantity',
            value: getRegistryItemPurchasedQuantity(state)
        }
    ];
}

export function getRemoveRemainingRegistryItemsEntity(state) {
    const product = getTargetedProduct(state);
    return [
        {
            op: 'test',
            path: '/version',
            value: product.productRegistry.registry.version
        },
        {
            op: 'replace',
            path: 'requested_quantity',
            value: getRegistryItemPurchasedQuantity(state)
        }
    ];
}
